import React from 'react';
import AdminLayout from '@/components/admin/AdminLayout';
import TimeclockPage from '@/pages/public/TimeclockPage';

export default function AdminPunchPage({ auth, onLogout }) {
  return (
    <AdminLayout auth={auth} onLogout={onLogout}>
      <div className="[&>div]:min-h-[calc(100vh-4rem)]" data-testid="admin-punch-page">
        <TimeclockPage embedded />
      </div>
    </AdminLayout>
  );
}
